import PersonsScroll from "./persons-scroll";

export default PersonsScroll;